<template>
  <modal 
    name="document-template-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'95%'"
    @before-open="beforeOpen"
    :height="'auto'"
    :scrollable="true">
    
    <div class="modal-header">
      <div class="modal-title">
        {{ title }}
      </div>

      <a href="#"
        @click.prevent="$modal.hide('document-template-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="">
      <template v-if="categories == null">
        <div class="text-center py-12">
          <img src="/static/img/ajax-loader.gif" class="inline" />
        </div>
      </template>

      <template v-else>

        <div class="px-6 pt-6">
          <InputText 
            label="Template name" 
            propertyKey="name"
            objectType="template"
            :value="template.name"
            :updateValue="updateValue" />

          <div v-if="nameError !== null" class="text-red-600 mt-1 text-sm">{{ nameError }}</div>

          <div class="mt-6">
            <label class="label-standard">Please select all the document types that you would like your client to upload</label>
          </div>
        </div>

        <div class="flex flex-wrap border-t-2 mt-2">
          <template v-for="(category, categoryIndex) in categories">
            <div :class="{ 'w-1/5' : true, 'border-l' : categoryIndex > 0 }" style="height:460px;overflow-y: auto;">
              <div class="px-6 py-2 border-b">
                <span class="text-sm font-semibold">{{ category.name }}</span>

                <span class="text-xs">
                  <span class="mx-1 text-gray-500">/</span>
                  <a href="#" @click.prevent="selectAllInCategory(categoryIndex)" class="text-gray-800 hover:underline">All</a>
                  <span class="mx-1 text-gray-500">/</span>
                  <a href="#" @click.prevent="selectNoneInCategory(categoryIndex)" class="text-gray-800 hover:underline">None</a>
                </span>
              </div>

              <template v-if="category.subcategories.length > 0">
                <template v-for="(subcategory, subcategoryIndex) in category.subcategories">
                  
                  <div :class="{ 'px-6 py-2 border-b bg-gray-200 leading-snug' : true, 'border-t' : subcategoryIndex > 0 }">
                    <span class="text-sm">{{ subcategory.name }}</span>
                    <span class="text-xs">
                      <span class="mx-1 text-gray-500">/</span>
                      <a href="#" @click.prevent="selectAllInSubcategory(categoryIndex, subcategoryIndex)" class="text-gray-800 hover:underline">All</a>
                      <span class="mx-1 text-gray-500">/</span>
                      <a href="#" @click.prevent="selectNoneInSubcategory(categoryIndex, subcategoryIndex)" class="text-gray-800 hover:underline">None</a>
                    </span>
                  </div>

                  <template v-for="(documentType, documentTypeIndex) in subcategory.document_types">
                    <div class="document-type">
                      <div class="flex">
                        <input type="checkbox" :id="'input-document-type-' + documentType.id" v-model="documentTypes" :value="documentType.id" />
                        <label :for="'input-document-type-' + documentType.id">
                          <template v-if="documentType.extension != null && documentType.extension.name != null && documentType.extension.name.length > 0">
                            {{ documentType.extension.name }}
                          </template>

                          <template v-else>{{ documentType.name }}</template>
                        </label>
                      </div>

                      <a href="#" @click.prevent="showDocumentTypeModal(documentType, categoryIndex, subcategoryIndex)" class="edit-document-type">
                       <svg width="12" height="12" stroke-width="2" class="text-gray-600 hover:text-gray-800" stroke="currentColor" fill="none">
                          <use xlink:href="/static/img/feather-sprite.svg#edit"/>
                        </svg>
                      </a>
                    </div>
                  </template>

                  <template v-for="(documentType, documentTypeIndex) in subcategory.custom_document_types">
                    <div class="custom-document-type" v-on:click="showCustomDocumentTypeModal(documentType, categoryIndex, subcategoryIndex)">
                      <input type="checkbox" 
                        :id="'input-document-type-' + documentType.id" 
                        v-model="documentTypes" 
                        :value="documentType.id"
                        v-on:click.stop />
                      
                      <div class="ml-5 flex items-center">
                        <label :for="'input-document-type-' + documentType.id">{{ documentType.name }}</label>
                        
                        <a href="#" @click.prevent.stop="deleteCustomDocumentType(documentType.id)">
                          <svg width="14" height="14" stroke-width="2" class="text-gray-700 hover:text-red-500" stroke="currentColor" fill="none">
                            <use xlink:href="/static/img/feather-sprite.svg#x"/>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </template>

                  <div class="px-6 py-2" v-if="$route.params.clientId != null">
                    <a href="#" @click.prevent="showCustomDocumentTypeModal({
                      name          : null,
                      category_id   : category.id,
                      subcategory_id: subcategory.id
                    }, categoryIndex, subcategoryIndex)" 
                      class="text-center py-1 rounded block bg-gray-600 hover:bg-green-600 text-xs font-semibold text-white">+ Custom Document Type</a>
                  </div>
                </template>
              </template>

              <template v-else>
                <template v-for="(documentType, documentTypeIndex) in category.document_types">
                  <div class="document-type">
                    <div class="flex">
                      <input type="checkbox" :id="'input-document-type-' + documentType.id" v-model="documentTypes" :value="documentType.id" />
                      <label :for="'input-document-type-' + documentType.id">
                        <template v-if="documentType.extension != null && documentType.extension.name != null && documentType.extension.name.length > 0">
                          {{ documentType.extension.name }}
                        </template>

                        <template v-else>{{ documentType.name }}</template>
                      </label>
                    </div>

                    <a href="#" @click.prevent="showDocumentTypeModal(documentType, categoryIndex, null)" class="edit-document-type">
                     <svg width="12" height="12" stroke-width="2" class="text-gray-600 hover:text-gray-800" stroke="currentColor" fill="none">
                        <use xlink:href="/static/img/feather-sprite.svg#edit"/>
                      </svg>
                    </a>
                  </div>
                </template>

                <template v-for="(documentType, documentTypeIndex) in category.custom_document_types">
                  <div class="custom-document-type" v-on:click="showCustomDocumentTypeModal(documentType, categoryIndex, null)">
                    <input type="checkbox" 
                      :id="'input-document-type-' + documentType.id" 
                      v-model="documentTypes" 
                      :value="documentType.id"
                      v-on:click.stop />
                    
                    <div class="ml-5 flex items-center">
                      <label :for="'input-document-type-' + documentType.id">{{ documentType.name }}</label>

                      <a href="#" class="ml-2" @click.prevent.stop="deleteCustomDocumentType(documentType.id)">
                        <svg width="14" height="14" stroke-width="2" class="text-gray-700 hover:text-red-500" stroke="currentColor" fill="none">
                          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                </template>

                <div class="px-6 py-2" v-if="$route.params.clientId">
                  <a href="#" 
                    @click.prevent="showCustomDocumentTypeModal({
                      name          : null,
                      category_id   : category.id,
                      subcategory_id: null,
                    }, categoryIndex)" 
                    class="text-center py-1 rounded block bg-gray-600 hover:bg-green-600 text-xs font-semibold text-white">+ Custom Document Type</a>
                </div>
              </template>
            </div>
          </template>
        </div>
      </template>
    </div>

    <div class="modal-footer">
      <SubmitButton2 label="Save" :onClick="submit" :loading="loading" />
    </div>

    <!-- <CustomDocumentTypeModal /> -->
  </modal>
</template>

<script>
  // import CustomDocumentTypeModal from './CustomDocumentTypeModal'
  import InputRadio     from '@/shared/components/form/InputRadio'
  import InputText      from '@/shared/components/form/InputText'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { EventBus }   from '@/shared/event-bus'

  export default {

    components : {
      // CustomDocumentTypeModal,
      InputRadio,
      InputText,
      SubmitButton2
    },

    data() {
      return {
        loading          : false,
        categories       : null,
        documentTypes    : [],
        documentTypeError: null,
        
        title    : null,
        nameError: null,
        template : null,
      }
    },

    mounted() {
      EventBus.$on('get-document-types', () => {
        this.getDocumentTypes()
      })
    },

    beforeDestroy() {
      EventBus.$off('get-document-types')
    },

    methods : {
      beforeOpen(event) {

        if(event.params.template != null) {
          this.title         = "Edit document template"
          this.template      = event.params.template
          this.documentTypes = this.template.data
        }

        else {
          this.title    = "Create a document template"
          this.documentTypes = []
          this.template = {
            type: 'document',
            name: null,
            data: [],
          }
        }

        // this.documentTypes = []
        // if(event.params.documents != null) {
        //   for(let i=0; i < event.params.documents.length; i++) {
        //     this.documentTypes.push(event.params.documents[i].document_type_id)
        //   }
        // }

        this.getDocumentTypes()
      },

      showDocumentTypeModal(documentType, categoryIndex, subcategoryIndex) {
        this.$modal.show('document-type-modal', {
          documentType    : documentType,
          categoryIndex   : categoryIndex,
          subcategoryIndex: subcategoryIndex
        })
      },

      getDocumentTypes() {
        this.apiGet({}, 'document/document-types', (categories) => {
          this.categories = categories
        })
      },

      selectAllInCategory(categoryIndex) {
        if(this.categories[categoryIndex].subcategories.length > 0) {
          for(let i=0; i < this.categories[categoryIndex].subcategories.length; i++) {
            for(let j=0; j < this.categories[categoryIndex].subcategories[i].document_types.length; j++) {
              this.documentTypes.push(this.categories[categoryIndex].subcategories[i].document_types[j].id)  
            }

            for(let j=0; j < this.categories[categoryIndex].subcategories[i].custom_document_types.length; j++) {
              this.documentTypes.push(this.categories[categoryIndex].subcategories[i].custom_document_types[j].id)  
            }
          }
        }

        else {
          for(let i=0; i < this.categories[categoryIndex].document_types.length; i++) {
            this.documentTypes.push(this.categories[categoryIndex].document_types[i].id)
          }

          for(let i=0; i < this.categories[categoryIndex].custom_document_types.length; i++) {
            this.documentTypes.push(this.categories[categoryIndex].custom_document_types[i].id)
          }
        }

        this.documentTypes = _.uniq(this.documentTypes)
      },

      selectNoneInCategory(categoryIndex) {
        if(this.categories[categoryIndex].subcategories.length > 0) {
          for(let i=0; i < this.categories[categoryIndex].subcategories.length; i++) {
            for(let j=0; j < this.categories[categoryIndex].subcategories[i].document_types.length; j++) {
              this.documentTypes = _.without(this.documentTypes, this.categories[categoryIndex].subcategories[i].document_types[j].id)
            }

            for(let j=0; j < this.categories[categoryIndex].subcategories[i].custom_document_types.length; j++) {
              this.documentTypes = _.without(this.documentTypes, this.categories[categoryIndex].subcategories[i].custom_document_types[j].id)
            }
          }
        }

        else {
          for(let i=0; i < this.categories[categoryIndex].document_types.length; i++) {
            this.documentTypes = _.without(this.documentTypes, this.categories[categoryIndex].document_types[i].id)
          }

          for(let i=0; i < this.categories[categoryIndex].custom_document_types.length; i++) {
            this.documentTypes = _.without(this.documentTypes, this.categories[categoryIndex].custom_document_types[i].id)
          }
        }
      },

      selectAllInSubcategory(categoryIndex, subcategoryIndex) {
        for(let i=0; i < this.categories[categoryIndex].subcategories[subcategoryIndex].document_types.length; i++) {
          this.documentTypes.push(this.categories[categoryIndex].subcategories[subcategoryIndex].document_types[i].id)  
        }

        for(let i=0; i < this.categories[categoryIndex].subcategories[subcategoryIndex].custom_document_types.length; i++) {
          this.documentTypes.push(this.categories[categoryIndex].subcategories[subcategoryIndex].custom_document_types[i].id)  
        }

        this.documentTypes = _.uniq(this.documentTypes)
      },

      selectNoneInSubcategory(categoryIndex, subcategoryIndex) {
        for(let i=0; i < this.categories[categoryIndex].subcategories[subcategoryIndex].document_types.length; i++) {
          this.documentTypes = _.without(this.documentTypes, this.categories[categoryIndex].subcategories[subcategoryIndex].document_types[i].id)
        }

        for(let i=0; i < this.categories[categoryIndex].subcategories[subcategoryIndex].custo_document_types.length; i++) {
          this.documentTypes = _.without(this.documentTypes, this.categories[categoryIndex].subcategories[subcategoryIndex].custo_document_types[i].id)
        }
      },

      showCustomDocumentTypeModal(documentType, categoryIndex, subcategoryIndex) {
        this.$modal.show('custom-document-type-modal', {
          documentType    : documentType,
          categoryIndex   : categoryIndex,
          subcategoryIndex: subcategoryIndex
        })
      },

      deleteCustomDocumentType(documentTypeId) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                documentTypeId : documentTypeId
              }, 'document/custom-document-type', () => {
                this.getDocumentTypes()
                EventBus.$emit('get-applicant-documents')
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Document deleted successfully"
                })
                this.$modal.hide('confirm-modal')
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },

      updateValue(params) {
        this.template[params.key] = params.value
      },
      
      submit() {
        let valid      = true
        this.nameError = null
        
        if(this.template.name == null || this.template.name.length == 0) {
          this.nameError = "Please provide a valid name for this template"
          valid = false
        }

        this.documentTypeError = null
        
        if(this.documentTypes.length == 0) {
          this.documentTypeError = "Please select document types"
          valid = false
        }

        if(valid) {
          this.loading = true
          this.template.data = this.documentTypes
          this.apiPost({
            template : this.template
          }, 'template/save', () => {
            this.loading = false
            this.$modal.hide('document-template-modal')
            EventBus.$emit('get-templates')
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Template saved successfully"
            })
          })
        }
      },
    }
  }
</script>

<style scoped>
  .document-type {
    @apply border-b px-6 py-2 text-sm flex justify-between;
  }

  .document-type:hover {
    @apply bg-gray-100;
  }

  .document-type input {
    margin-top:4px;
  }

  .document-type label {
    @apply ml-2 leading-snug;
  }

  .document-type a.edit-document-type {
    @apply text-xs text-gray-600 mt-1 invisible;
  }

  .document-type:hover a.edit-document-type {
    @apply visible;
  }

  .custom-document-type {
    @apply border-b px-6 py-2 text-sm overflow-hidden text-purple-700;
  }

  .custom-document-type:hover {
    @apply bg-gray-100;
  }

  .custom-document-type input {
    @apply float-left;
    margin-top:3px;
  }

  .custom-document-type label {
    @apply block leading-snug;
  }
</style>